import { Form } from 'react-bootstrap';
import { AddEditProps, Client } from '../models/table-models';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import CommonInputText from '../components/CommonInputText';
import { editClient, saveClient } from '../utils/clients-hooks';
import {ClientSubForm} from "../components/NewRequest/ClientSubForm";
import React from "react";
import {defaultSelectedClient} from "../utils/Enums/NewRequest";
import {useGetClientPrefix} from "../utils/custom-hooks";

export const AddEditClient = ({ itemToEdit, setShowModal, refetchEntitiesHook }: AddEditProps<Client>) => {
    const { t } = useTranslation('translation', { keyPrefix: 'newRequest' });

    const { register, handleSubmit, formState, watch, control, setValue } = useForm<Client>({
        defaultValues: itemToEdit?.id ? itemToEdit : defaultSelectedClient ,
        mode: 'all',
    });

    const clientVatPrefix = useGetClientPrefix(itemToEdit?.vatPrefix);

    const useSubmitHandlerAdd = async (formValue: Client) => {
        const dataToPass = { ...formValue, vatPrefix: clientVatPrefix, id: 0 };
        await saveClient(dataToPass);
        refetchEntitiesHook();
        setShowModal(false);
    };

    const useSubmitHandlerEdit = async (formValue: Client) => {
        await editClient(formValue, itemToEdit?.id);
        
        refetchEntitiesHook();
        setShowModal(false);
    };

    return (
        <Form
            id='form'
            className='d-flex flex-column align-items-center p-4  w-100'
            noValidate
            onSubmit={itemToEdit ? handleSubmit(useSubmitHandlerEdit) : handleSubmit(useSubmitHandlerAdd)}
        >
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='companyName'
                    label={t('name')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.companyName}
                    type='text'
                    fieldError={formState.errors.companyName}
                    hookRegister={register('companyName', {
                        required: {
                            value: true,
                            message: t('name'),
                        },
                    })}
                />
            </Form.Group>
            <ClientSubForm control={control}
                           watch={watch}
                           disabled={false}
                           clientVatPrefix={clientVatPrefix}
                           editForm={true}
                           formState={formState}
                           setValue={setValue}
            />
        </Form>
    );
};
